import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** MANAGE TAX COMPONENTS API CONFIG                                                       ***!
  \*******************************************************************************/

export const apiConfig = {
  Clients: BOM.baseUrl("clients"),
  Client: BOM.baseUrl("client"),
  FixedDepositAccounts: BOM.baseUrl("fixeddepositaccounts"),
  LoanAccounts: BOM.baseUrl("loans"),
  savingsAccounts: BOM.baseUrl("savingsaccounts"),
  standingInstruction: BOM.baseUrl("standinginstruction"),
  standingInstructions: BOM.baseUrl("standinginstructions"),
  relationship: BOM.baseUrl("familymembers"),
  charges: BOM.baseUrl("charges"),
  accounts: BOM.baseUrl("accounts"),
  Search: BOM.baseUrl("search"),
  ClientLimit: BOM.baseUrl("client-limit"),
  Savings: BOM.baseUrl("savings"),
  Journalentries: BOM.baseUrl("journalentries"),
  detailJournalEntry: BOM.baseUrl("journalentries?transactionDetails=true&transactionId"),
  JournalEntries: BOM.baseUrl("journalentries"),
  Offices: BOM.baseUrl("offices"),
  GlAccounts: BOM.baseUrl("glaccounts"),
  rescheduleloans: BOM.baseUrl("rescheduleloans"),
  savingsAccountDetails: BOM.baseUrl("savingsaccountdetails"),

  certificateTemplates: BOM.baseUrl("certificatetemplates", "treasury"),
  certificates: BOM.baseUrl("certificates", "treasury"),

  //CURRENT ACCOUNT
  AccountTransfers: BOM.baseUrl("accounttransfers"),
  Codes: BOM.baseUrl("codes"),
  rovapassfortAccount: BOM.baseUrl("rovapassfortAccount"),
  fxtransactions: BOM.baseUrl("fxtransactions"),
  savingsaccountdetails: BOM.baseUrl("savingsaccountdetails"),
  //END OF CURRENT ACCOUNT
  GetCasaProductList: BOM.baseUrl("savingsproducts"),
  DetailCasaProductList: BOM.baseUrl("savingsproducts"),
  GetTemplateProductList: BOM.baseUrl("savingsproducts/template"),
  NewCasaProductList: BOM.baseUrl("savingsproducts"),
  GetCasaProductCharges: BOM.baseUrl("/charges"),
  EditCasaProductList: BOM.baseUrl("savingsproducts"),

  Recurringdepositaccounts: BOM.baseUrl("recurringdepositaccounts"),
};
//
/*!*******************************************************************************!
  !*** CUSTOMER LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  manageCustomer: "Manage Customer",
  newCustomer: "New Customer",
  detailCustomer: "Customer Detail",
  generalInfo: "General Information",
  currencyInfo: "Currency Information",
  selectedInfo: "Selected Charge Information",
  overdraftInfo: "Overdraft Information",
  interestInfo: "Interest Information",
  additionalInfo: "Additional Information",
  currentAccountSetup: "Account Setup",
  editCustomer: "Edit Customer",
  customerSetup: "Customer Setup",
  addressInfo: " Address Information",
  additionalInfo: "Additional Information",
  work: "Work",
  home: "Home",
  active: "Active",
  status: "Status",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  customerDisplayName: "Customer Display Name",
  customerClassification: "Customer Classification",
  staff: "Relationship Manager",
  isStaff: "is Staff",
  dateOfBirth: "Date of Birth",
  identifactionType: "Identification Type",
  identifactionNo: "Identification No.",
  selectCasaProduct: "Select CASA Product",
  issuingAuthority: "Issuing Authority",
  expiryDate: "Expiry Date",
  submittedOn: "Created Date",
  createdDate: "Created Date",
  gender: "Gender",
  homeAddress: "Home Address",
  addressOne: "Address Line 1",
  addressTwo: "Address Line 2",
  addressThree: "Address 3",
  city: "City",
  stateProvince: "State / Province",
  postalCode: "Postal Code",
  street: "Street",
  addressTypeId: "Address Type",
  // streetTwo: "Street 2",
  // streetThree: "Street 3",
  workAdress: "Work Address",
  others: "Others",
  personalEmail: "Personal Email",
  workEmail: "Work Email",
  otherEmail: "Other Email",
  homePhone: "Home Phone",
  workPhone: "Work Phone",
  mobilePhone: "Mobile Phone",
  mobileNumber: "Mobile Number",
  kycLevel: "KYC Level",
  customerClass: "Customer Class",
  customerType: "Customer Type",
  customerCategory: "Customer Category",
  upload: "Upload",
  clientNo: "Client Number",
  legalForm: "Customer Type",
  fullname: "Full Name",
  documentType: "DocumentType",
  deleteDocumentMsg: "Document was successfully deleted",
  casaAccount: "Current and Savings Account(s)",
  casaAccountDetail: "Current and Savings Account Detail",
  loanAccountDetail: "Loan Account Detail",
  LoanAccount: "Loan Account(s)",
  newCustomerMsg: "Customer was successfully created",
  editCustomerMsg: "Customer was successfully edited",
  deleteCustomerMsg: "Customer was successfully deleted",
  branch: "Branch",
  newAddress: "New Address",
  editAddress: "Edit Address",
  newAddressMsg: "Address was successfully created",
  editAddressMsg: "Address was successfully edited",
  addressSetup: "Address Setup",
  latitude: "Latitude",
  longitude: "Longitude",
  closureReason: "Closure Reason",
  closureDate: "Closure Date",
  closeLoanAccount: "Close Loan Account",
  customerClosureMsg: "Customer account is successfully closed",
  cardInfo: "Cards",
  walletInfo: "H/Wallets",
  bioInfo: "Bio Info",
  foreName: "Fore Name",
  previousName: "Previous Name",
  title: "Title",
  counterpartParent: "Counterpart Parent",
  deviceID: "Device ID",
  nationalID: "National ID",
  relationshipInfo: "Relationship Info",
  customerDirectorIndicator: "Customer Director Indicator",
  establishedRelationshipFlag: "Established Relationship Flag",
  businessInfo: "Business Info",
  institutionalSectorCode: "Institutional Sector Code",
  bankOfEnglandIndustryCode: "Bank Of England Industry Code",
  NACECode: "NACE Code",
  retailFlag: "Retail Flag",
  SMEFlag: "SME Flag",
  numberOfEmployees: "Number of Employees",
  annualTurnover: "Annual Turnover",
  centralBankCode: "Central Bank Code",
  intercompanyFlag: "Inter Company Flag",
  shortLong: "Short / Long Term Rating",
  ratingAgency: "Rating Agency",
  creditRatingCode: "Credit Rating Code",
  centralGovernmentRatingIndicator: "Central Government Rating Indicator",
  nationalCode: "National Code",
  mnemonic: "Mnemonic",
  smallerCompanyFlag: "Smaller Company Flag",
  institutionWhereClient: "Institution Where Client Money Is Placed",
  segregationType: "Segregation Type",
  typeOfClientAccount: "Type Of Client Account",
  frequency: "Frequency Internal Client Reconciliation",
  frequencyExternal: "Frequency External Client Reconciliation",
  treasuryDealersLines: "Treasury Dealers Lines",
  buildingSocietyMemberFlag: "Building Society Member Flag",
  largeExposuresExempt: "Large Exposures Exempt",
  countryOfResidence: "Country Of Residence",
  countryOfRisk: "Country Of Risk",
  countryOfIncorporation: "Country Of Incorporation",
  countryOfBirth: "Country Of Birth",
  townOfBirth: "Town Of Birth",
  daytimePhoneNo: "Daytime Phone Number",
  eveningPhoneNo: "Evening Phone Number",
  careOf: "Care Of",
  requiresBraille: "Requires Braille",
  nonPerformingFlag: "Non Performing Flag",
  taxID: "Tax ID",
  addedTaxJurisdiction: "Added Tax Jurisdiction",
  country: "Country",
  statusInfo: "Status Info",
  entityClassification: "Entity classification",
  sanctioned: "Sanctioned",
  politicallyExposed: "Politically Exposed",
  deceased: "Deceased",
  customerStatus: "Customer Status",
  DGSEligible: "DGS Eligible",
  goneAway: "Gone Away",
  DGSEligibleReason: "DGS Eligible Reason",
  transferType: "Transfer Type",
  fromAccountType: "From Account Type",
  clientName: "Client Name",
  clientId: "Client Id",
  toDate: "To Date",
  fromDate: "From Date",
  fromAccountId: "From Account Id",
  viewClosed: "View Closed",
  viewActive: "View Active",
  addressStatus: "Address Status",
  activationDate: "Activation Date",
  email: "Email",
  nationality: "Nationality",
  contactInfo: "Contact Information",
  remove: "Remove",
  openCasaAccount: "Open CASA Account?",
  issuingDate: "Issuing Date",
  name: "Name",
  incorporationDate: "Incorporation Date",
  incorporationValidUntil: "Incorporation Valid Until",
  incorporationValidDate: "Incorporation Valid Date",
  incorporationNumber: "Incorporation Number",
  constitution: "Constitution",
  mainBusinessLine: "Main Business Line",
  remarks: "Remarks",
  accountNo: "Account No",
  sourceOfWealth: "Source of Wealth",
  pepStatus: "PEP Status",
  riskRating: "Risk Rating",
  manageLoanAccount: "Loan Accounts",
  newLoanAccount: "New Loan Account",
  product: "Product",
  productSetup: "Product Setup",
  customer: "Customer",
  loanOfficer: "Loan Officer",
  loanPurpose: "Loan Purpose",
  fund: "Fund",
  submittedDate: "Submitted Date",
  disbursementOn: "Disbursement On",
  externalId: "External ID",
  linkSavings: "Link Savings",
  createStandingInstructions: "Create standing instructions at disbursement:",
  principal: "Principal",
  loanTerm: "Loan Term",
  numberOfRepayments: "Number of Repayments",
  repaidEvery: "Repaid Every",
  dayOfWeek: "Day of Week",
  on: "On",
  repaymentFrequency: "Repayment Frequency",
  option: "Option",
  firstRepaymentOn: "First Repayment On",
  interestChargedFrom: "Interest Charged From",
  nominalInterestRate: "Nominal Interest Rate",
  amortization: "Amortization",
  isEqualAmortization: "Is Equal Amortization",
  interestMethod: "Interest Method",
  interestCalculationPeriod: "Interest Calculation Period",
  calculateInterest: "Calculate interest for exact days in partial period",
  interestFreePeriod: "Interest Free Period",
  arrearsTolerance: "Arrears Tolerance",
  repaymentStrategy: "Repayment Strategy",
  moratorium: "Moratorium",
  onPrincipalPayment: "On Principal Payment",
  onInterestPayment: "On Interest Payment",
  charge: "Charge",
  collateral: "Collateral",
  value: "Value",
  penalInterest: "Penal interest",
  description: "Description",
  newRelationship: "New Relationship",
  qualification: "Qualification",
  age: "Age",
  isDependent: "Is Dependent?",
  relationshipType: "Relationship",
  profession: "Profession",
  maritalStatus: "Marital Status",
  newRelationshipCreatedMsg: "New Relationship was successfully created",
  editRelationship: "Edit Relationship",
  editRelationshipMsg: "Relationship was successfully edited",
  deleteRelationshipMsg: "Relationship was successfully deleted",
  current: "Current",
  currentAccount: "Current Account",
  currentAccounts: "Current Accounts",
  savings: "savings",
  savingsAccount: "Savings Account",
  savingsAccounts: "Savings Accounts",
  depositAccount: "Deposit Account",
  depositAccounts: "Deposit Accounts",
  loansAccount: "Loan Account",
  manageLoanAccount: "Manage Loan Account",
  manageDepositAccount: "Manage Deposit Account",
  accounNumber: "Account Number",
  accountName: "Account Name",
  customerId: "Customer Id",
  actions: "Actions",
  currentBalance: "Current Balance",
  availableBalance: "Available Balance",
  savingsAccountDetails: "Savings Account Details",
  accountOfficer: "Account Officer",
  maturityDate: "Maturity Date",
  period: "Period",
  periodType: "Period Type",
  performanceHistory: "Performance History",
  principalAmount: "Principal Amount",
  maturityAmount: "Maturity Amount",
  totalDeposits: "Total Deposits",
  financialInformation: "Financial Information",
  nominalInterestrate: "Nominal Interest Rate",
  interestCompoundingPeriod: "Interest Compounding Period",
  interestPostingPeriod: "Interest Posting Period",
  interestCalculatedUsing: "Interest Calculated Using",
  daysInYear: "Days In Year",
  prelosurePenalInterestLess: "Pre-closure penal Interest (less)",

  currency: "Currency",
  decimalPlaces: "Decimal Places",
  currencyInMultiplesOf: "Currency In Multiples Of",
  norminalAnnualInterest: "Nominal Annual Interest(%)",
  minimumOpeningBalance: "Minimum Opening Balance",
  lockInPeriod: "Lock-in Period",
  lockinPeriodFrequencyType: "Lockin Period Frequency Type",
  applyWithdrawalFeeForTransfers: "Apply Withdrawal Fee for Transfers",
  isOverdraftAllowed: "Is Overdraft Allowed?",
  maxOverdraftAmountLimit: "Max Overdraft Amount limit",
  nominalAnnualInterestForOverdraft: " Nominal annual interest rate for overdraft",
  minOverdraftRequiredForInterestCalculation: "Min Overdraft Required for interest Calculation",
  isLienAllowed: " Is Lien Allowed",
  maximumLienAmountLimit: "Maximum Lien Amount Limit",
  enforceMinimumBalance: "Enforce Minimum Balance",
  minimumBalance: "Minimum Balance",
  customerName: "Customer Name",
  charges: "Charges",
  chargeCalculation: "Charge calculation",
  chargeCalculationType: "Charge calculation Type",
  chargeTimeType: "Charge time type",
  dueForCollectionOn: "Due for collection on",
  amount: "Amount",
  newChargeMsg: "Charge was successfully created",
  editChargeMsg: "Charge was successfully edited",
  deleteChargeMsg: "Charge was successfully deleted",
  reversedChargeMsg: "Charge_Action was successfully Reversed",
  payChargeMsg: "Charge was successfully Paid",
  waivedChargeMsg: "Charge was successfully Waived",
  editChargeMsg: "Charge was successfully Edited",
  add: "Add",
  addPeriod: "Add Period",
  applicant: "Applicant ",
  type: "Type",
  loansAccounts: "Loans Accounts",
  priority: "Priority",
  fromAccount: "From Account",
  destination: "Destination",
  toBranch: "To Branch",
  beneficiary: "Beneficiary",
  toAccountType: "To Account Type",
  toAccount: "To Account",
  standingInstructionType: "Standing Instruction Type ",
  validityFrom: "Validity from",
  to: "Validity Till",
  recurrenceType: "Recurrence type",
  interval: "Interval ",
  recurrenceFrequency: "Recurrence Frequency ",
  onMonthDay: "On Month Day ",
  newStandingInstructionMsg: "Standing Instruction was successfully created",
  editStandingInstructionMsg: "Standing Instruction was successfully edited",
  deleteStandingInstructionMsg: "Standing Instruction was successfully deleted",
  beneficiaryInfo: "Beneficiary Information",
  instructionInfo: "Instruction Information",
  detailStandingInstruction: "Standing Instruction Detail",
  editStandingInstruction: "Edit Standing Instruction",
  standingInstructionSetup: "Standing Instruction Setup",
  detailCharge: "Charge Detail",
  editCharge: "Edit Charge",
  payCharge: "Pay Charge",
  waived: "Waived",
  paid: "Paid",
  outstanding: "Outstanding",
  due: "Due",
  dueAsOf: "Due as Of",
  transactions: "Transactions",
  transactionDate: "Transaction Date",

  principal: "Principal",
  loanTerm: "Loan Term",
  numberOfRepayments: "Number of Repayments",
  firstRepaymentOn: "First Repayment On",
  interestChargedFrom: "Interest Charged From",
  nominalInterestRate: "Nominal Interest Rate",
  interestMethod: "Interest Method",
  amortization: "Amortization",
  newLoanAccountMsg: "Loan Account was successfully created",
  loanTrancheDetails: "Loan Tranche Details",
  recalculateInterest: "Recalculate Interest",
  daysinYear: "Days In Year",
  advancePayments: "Advance payments adjustment type",
  daysInMonth: "Days In Month",
  interestRecalculationCompounding: "Interest recalculation compounding on",
  FrequencyForRecalculate: "Frequency for recalculate Outstanding Principal",
  maximumAllowedOutstanding: "Maximum allowed outstanding balance",
  customerInfo: "Customer Information",
  refresh: "Refresh",
  customerName: "Customer Name",
  customerNumber: "Customer Number",
  loanPrepayment: "Loan Prepayment",
  addLoanCharge: "Add Loan Charge",
  assignLoanOfficer: "Assign Loan Officer",
  foreClosure: "Foreclosure",
  makeRepayment: "Make Repayment",
  undoDisbursal: "Undo Disbursal",
  undoApproval: "Undo Approval",
  waiveInterest: "Waive Interest",
  reschedule: "Reschedule Loan",
  rescheduleRequest: "Loan Reschedule Request",
  writeOff: "Write Off Loan Account",
  close: "Close",
  closeAsRescheduled: "Close As Rescheduled",
  loanScreenReports: "Loan Screen Reports",
  viewGuarantors: "View Guarantors",
  createGuarantor: "Create Guarantor",
  recoverFromGuarantor: "Recover From Guarantor",
  charge: "Charge",
  transactionAmount: "Transaction Amount",
  transactionDate: "Transaction Date",
  interestAmount: "Interest Amount",
  paymentTypes: "Payment Types",
  showPaymentDetails: "Show Payment Details",
  note: "Note",
  accountNumber: "Account Number",
  chequeNumber: "Cheque Number",
  routingCode: "Routing Code",
  receiptNumber: "Recipient Number",
  routingCode: "Routing Code",
  toLoanOfficer: "To Loan Officer",
  assignmentDate: "Assignment Date",
  interest: "Interest",
  feeAmount: "Fee Amount",
  penaltyAmount: "Penalty Amount",
  interestWaivedOn: "Interest Waived On",
  liabilityCategory: "Liability Category",
  limitInformation: "Limit Information",
  limitEndDate: "Limit End Date",
  globalLimit: "Global Limit",
  amountInformation: "Amount Information",
  utilizationInformation: "Utilization Information",
  accountLimit: "Account Limit",
  cardLimit: "Card Limit",
  utilizedLimit: "Utilized Limit",
  unUsedLimit: "Un-used Limit",
  revolvingLine: "Revolving Line",
  retrieveCollateral: "Track Collateral",
  newLimitMsg: "Limit was successfully created",
  unAuthorisedLimit: "Unauthorised Limit",
  digitsAfterDecimal: "Digits After Decimal",
  inMultiplesOf: "In Multiples Of",
  inMultiplesOfType: "in Multiples Of Type",
  liabilityId: "Liability Id",
  limitLineNo: "LimitLine Number",
  reOpen: "Re-Open",
  updateLimitMsg: "Limit was successfully updated",
  chargeTime: "Charge Time",

  bban: "BBAN",
  depositIban: "Deposit Iban",
  interestEarned: "Interest earned",
  withdrawalFee: "Withdrawal fee",
  lastActiveTransactionDate: "Last Active Transaction Date",
  annualFee: "Annual fee",
  maxOverdraftLimit: "Max Overdraft limit",
  interestRecalculationDate: "Interest Recalculation Date",
  totalWithdrawalsFees: "Total withdrawals fees",
  totalAnnualFees: "Total annual fees",
  interestEarned: "Interest earned",
  interestPosted: "Interest posted",
  lienBlockedAmount: "Lien(Blocked Amount)",
  earnedInterestNotPosted: "Earned interest not posted",
  customerStatusMsg: "Customer status was successfully updated",
  date: "Date",
  delete: "Delete",
  deleted: "Deleted",

  manageFixedDepositAccount: "Manage Fixed Deposit Account",
  accountNumber: "Account Number",
  productName: "Product Name",
  shortName: "Short Name",
  lastActive: "   Last Active",
  balance: "Balance",
  newFixedDepositAccount: "New Fixed Deposit Account",
  fixedDepositAccountList: "Fixed Deposit Account List",
  newFixedDepositAccountMsg: "Fixed Deposit Account was successfully created",
  fieldOfficer: "Field Officer",
  usDollar: "US Dollar",
  defaultDepsoitAmount: "Default Deposit Amount",
  minimumDepositAmount: "Minimum Deposit Amount",
  maximumDepositAmount: "Maximum Deposit Amount",
  depositPeriod: "Deposit Period",
  depositPeriodFrequency: "Deposit Period Frequency",
  minimumDepositTerm: "Minimum Deposit Term",
  minimumDepositTermTypes: "Minimum Deposit Term Type",
  thereAferTerms: "And Thereafter, In Multiples Of",
  maximumDepositTerm: "Maximum Deposit Term",
  maximumDepositTermType: "Maximum Deposit Term Type",
  preMatureClosure: "Apply Penal Interest for Pre-mature Closure?",
  transferInterestToLinkedSavingsAccount: "Transfer Interest to Linked Savings Account",
  maturityInstruction: "Maturity Instruction",
  transferToSavingsAccount: "Transfer To Savings Account ",
  validfromDate: "Valid Start Date",
  isWithholdTax: "is Withhold Tax Applicable",
  endDate: "End Date",
  isPrimaryGroupingByAmnt: "Is Primary Grouping By Amount",
  add: "Add",
  detailFixedDepositAccount: " Fixed Deposit Account Detail ",
  savingsDetails: "Savings Details",
  depositIban: "Deposit IBAN",
  daily: "Daily",
  averageDailyBalance: "Average Daily Balance",
  unAssigned: "Unassigned",
  notProvided: "Not Provided",
  editFixedDepositAccount: "Edit Fixed Deposit Account",
  editFixedDepositAccDetails: "Edit Fixed Deposit Account Details",
  datePastDue: "Date Past Due",
  lastRate: "Last Rate Change Date",
  interestEarned: "Interest Earned",
  finInterest: "FIN Interest Earned",
  ytdInterest: "YTD Interest Earned",
  contractReference: "Contract Reference",
  dsgInsured: "DSG Insured Amount",
  dsgUninsured: "DSG Uninsured Amount",
  hedgingPortf: "Hedging Portfolio Ref",
  daysPastDue: "Days Past Due",
  nonPerforming: "Non Performing",
  stressWithdrawal: "Stress Withdrawal",
  transactionalAcc: "Transactional Account",
  suspectedLaundering: "Suspected Money Laundering",
  fraud: "Fraud",
  legallyDisputed: "Legally Disputed",
  undocumentedAcc: "Undocumented Account",
  repoReference: "Repo Reference Cash Leg",
  universalSourceSys: "Universal Source System",
  structuredDepositAcc: "Structured Deposit Account",
  operationalDeposit: "Operational Deposit",
  universalBranchId: "Universal Branch Id",
  accountStatusCode: "Account Status Code",
  jurisdiction: "Jurisdiction",
  transferableEligbleDep: "Transferable Eligble Deposit",
  iban: "IBAN",
  swiftCode: "swift Code",
  wireRoutingNo: "Wire Routing No",
  upic: "UPIC",
  accountHolderInd: "Account Holder Indication",
  extensionCode: "Extension Code",
  bankRecovery: "Bank Recovery",
  sortCode: " Sort Code",
  extensionAccNo: "Extension Account No",
  achRoutingNo: "Ach Routing No",
  bban: "BBAN",
  bic: "BIC",
  dormantDate: "Dormant Date",
  debitInterestRate: "Debit Interest Rate",
  ifrsPortfolioType: "IFRS9 Portfolio Type",
  dateOfPerformance: "Date of Performance Status Change",
  symmetricalInflow: "Symmetrical Inflow Rate",
  universalHqla: "Universal HQLA Indicator",
  accountBalanceLocalCurrency: "Account Balance Local Currency",
  typeOfBusinessActivity: "Type of Business Activity",
  typeOfClientAccForCass: "Type of Client Account for CASS",
  linkedToPeriodicRfRate: "Linked to periodic reference rate",
  universalImpairmentStatus: "Universal Impairment Status",
  facilityReference: "Facility Reference",
  portfolioType: "Portfolio Type",
  rateSpread: "Rate Spread",
  performingStatus: "Performing Status",
  lastIntrstCapDate: "Last Interest Capitalisation Date",
  clientMoneyPlaced: "Client Money Placed",
  instWhereTheClMnPlcd: "Institution where the client money is placed",
  clientAccAckLetter: "Client Account Acknowledgment Letter",
  universalAccumImpAmnt: "Universal Accumulated Impairment Amount",
  transcAccFlagBranchRt: "Transactional Account Flag (Branch Return)",
  universalGlMarker: "Universal GL Marker",
  overdrawnLimit: "Overdrawn Limit",
  purposeType: "Purpose Type",
  ldStartDate: "LD Start Date",
  ldMaturityDate: "LD Maturity Date",
  repaymentType: "Repayment Type",
  remainingTerm: "Remaining Term",
  interestMargin: "Interest Margin",
  rollOverIndicator: "Rollover Indicator",
  formalArrangmentSf: "Formal Arrangement for shortfall",
  lastCstDrivenTransaction: "Last customer driven transaction",
  irregularSchedule: "Irregular Schedule",
  nextRollOverDate: "Next Rollover Date",
  lastRollOverDate: "Last Rollover Date",
  originalTerm: "Original Term",
  assessmentType: "Assessment Type",
  loanPurchased: "Loan Purchased",
  additionalStricter: "Additional Stricter Prudential Requirements Flag",
  encumberedAssetFlag: "Encumbered Asset Flag",
  coveredByDgs: "Covered by DGS",
  encumberedAmount: "Encumbered Amount",
  paymentsSuspended: "Payments Suspended",
  termExtension: "Term Extension",
  nonPerfBfForBearance: "Non-performing before Forbearance Measures",
  dateOfFormalArrang: "Date of formal arrangement",
  dateOfTermExtension: "Date of term extension",
  dateOfOtherForBearance: "Date of other forbearance",
  loanToValue: "LTV (Loan to Value)",
  coverPoolID: "Cover Pool ID",
  impairmentStartDate: "Impairment Start Date",
  temporarySwitchToInt: "Temporary switch to interest-only",
  reducedPayment: "ReducedPayment",
  otherForBearance: "Other forbearance",
  centralBankEligibleFlag: "Central Bank Eligible Flag",
  dateOfInterestOnlySwitch: "Date of interest-only switch",
  dateLitigationAction: "Date litigation action started",
  universalIntOnMaturity: "Universal Interest On Maturity",
  nettingFlag: "Netting Flag",
  interestReversionDate: "Interest Reversion Date",
  loanCollateralPoolRf: "Loan Collateral Pool Reference",
  accountDescription: "Account Description",
  localCurrencyCode: "Local Currency Code",
  applicationReference: "Application Reference",
  dateOfReducedPayment: "Date of reduced payment",
  accBalanceLocalCurrency: "Account Balance Local Currency",
  gbp: "GBP",

  clientID: "Client ID",
  name: "Name",
  externalID: "External ID",
  status: "Status",
  branch: "Branch",
  staff: "Staff",
  customerList: "Customer List",
  show: "Show",
  entries: "Entries",
  searchByName: "Search by Name...",
  download: "Download",
  remove: "Remove",
  client: "Client #",
  addCustomer: "Add Customer",
  edit: "Edit",
  delete: "Delete",
  approve: "Approve",
  dissaprove: "Dissaprove",
  backToTop: "Back to Top",
  home: "Home",
  manageCustomers: "Manage Customers",
  nameAndContact: " Name and Contact",
  customerType: "Customer Type",
  individual: "Individual",
  company: "Company",
  title: "Title",
  mr: "Mr.",
  ms: "Ms.",
  mrs: "Mrs.",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  customerDisplayName: "Customer Display Name",
  dateOfBirth: "Date of Birth",
  countryOfBirth: "Country of Birth",
  pleaseSelectAValue: "Please Select a value",
  countryOfResidence: "Country of Residence",
  idType: "Identification Type",
  idNumber: "Identification No.",
  issuingAuthority: "Issuing Authority",
  expiryDate: "Expiry Date",
  gender: "Gender",
  male: "Male",
  female: "Female",
  homeAddress: " Home Address",
  address1: "Address 1",
  address2: "Address 2",
  address3: "Address 3",
  workAddress: " Work Address",
  others: " Others",
  personalEmail: "Personal Email",
  workEmail: "Work Email",
  otherEmail: "Other Email",
  homePhone: "Home Phone",
  workPhone: "Work Phone",
  mobilePhone: "Mobile Phone",
  kycLevel: "KYC Level",
  customerClass: "Customer Class",
  customerCategory: "Customer Category",
  submit: "Submit",
  cancel: "Cancel",
  southAfrica: "South Africa",
  nigeria: "Nigeria",
  kenya: "Kenya",
  customButton: "CustomButton",
  viewCustomer: "View Customer",
  authorised: "Authorised",
  editCustomers: "Edit Customers",

  back: "Back",
  number: "+27 60 971 9460",
  kycGroup: "KYC Group",
  investment: "Investment",
  fixedAsset: "Fixed Asset",
  currentAssets: "Current Assets",
  cash: "Cash",
  inventory: "Inventory",
  accountsReceivable: "Accounts Receivable",
  totalAssets: "Total Assets",
  assetPosition: "Asset Position",
  totalLiabilities: "Total Liabilities",
  liabilityPosition: "Liability Position",
  customerID: "Customer ID",
  liability: "Liability",
  bioInfo: " Bio Info",
  foreName3: "ForeName3",
  noData: "No Data",
  previousName: "Previous Name",
  counterPartyParent: "Counterparty Parent",
  deviceID: "Device ID",
  nationalID: "National ID",
  relationShipInfo: "Relationship Info",
  customerDirectorIndicator: "Customer Director Indicator",
  establishedRelationShipFlag: "Established Relationship Flag",
  businessInfo: "  Business Info",
  institutionalSectorCode: "Institutional Sector Code",
  bankOfEnglandIndCode: "Bank Of England Industry Code",
  naceCode: "NACE Code",
  retailFlag: "Retail Flag",
  smeFlag: "SME Flag",
  numberOfEmployees: "Number Of Employees",
  annualTurnover: "Annual Turnover",
  centralBankCode: "Central Bank Code",
  interCompanyFlag: "Intercompany Flag",
  shortAndLongTermRating: "Short / Long Term Rating",
  ratingAgency: "Rating Agency",
  creditRatingCode: "Credit Rating Code",
  centralGovmntRatingInd: "Central Government Rating Indicator",
  nationalCode: "National Code",
  mnemonic: "Mnemonic",
  smallerCompanyFlag: "Smaller Company Flag",
  instWhereClientMoneyIsPaid: "Institution Where Client Money Is Placed",
  segregationType: "Segregation Type",
  typeOfClientAccount: "Type Of Client Account",
  frequencyInternal: "Frequency Internal Client Reconciliation",
  frequnecyExternal: "Frequency External Client Reconciliation",
  treasuryDealerLines: "Treasury Dealers Lines",
  buildingSocietyMemberFlag: "Building Society Member Flag ",
  largeExposuresExempt: "Large Exposures Exempt",
  contactInfo: "Contact Info",
  countryOfRisk: "Country of Risk",
  countryOfIncorporation: "Country Of Incorporation",
  townOfBirth: "Town Of Birth",
  dayTimePhoneNo: "Daytime Phone No ",
  eveningPhoneNo: "Evening Phone No",
  careOf: "Care-Of",
  requiresBraille: "Requires Braille",
  taxInfo: " Tax Info",
  taxGroup: " Tax Group",
  nonPerformingFlag: "Non Performing Flag ",
  taxID: "Tax ID",
  addedTaxJuri: " Added Tax Jurisdiction",
  statusInfo: " Status Info",
  entityClassification: "Entity Classification",
  sanctioned: "Sanctioned",
  politicallyExposed: "Politically Exposed",
  deceased: "Deceased",
  customerStatus: "Customer Status",
  dgsEligible: "DGS Eligible ",
  goneAway: "Gone Away",
  dgsEligibleReason: "DGS Eligible Reason",

  limit: "Limit",
  globalLimit: "Global Limit",
  add: "Add",
  utilisedLimit: "Utilised Limit",
  unUsedLimit: "Un-used Limit",
  accountLimit: "Account Limit",
  cardLimit: "Card Limit",
  unAuthorisedLimit: "Un-Authorised Limit",
  liabilityB: "Liability",
  liabilityID: "Liability ID",
  loanAndAdvances: "Loan & Advances",
  viewCollateral: "  View Collateral",
  secured: "Secured",
  unSecured: "Unsecured",
  overdraft: "Overdraft",
  guarantee: "Guarantee",
  bnpl: "BNPL",

  addSignatory: "Add Signatory",
  assignPrivileges: "Assign Privileges",
  assignLimits: "Assign Limits",
  customerAdded: "This customer is already added!",
  successFullyDeleted: "Successfully deleted!",
  customerIdentification: "Customer Identification",
  searchByCustomerID: "Search by Customer ID",
  fullName: "Full Name",
  addedSignatory: "Added Signatory",
  remove: "Remove",
  passPortNo: "Passport No.",
  selectSignatory: "Select Signatory",
  availablePrivileges: "Available Privileges",
  assign: "Assign",
  assignedPrivileges: "Assigned Privileges",
  save: "Save",
  transactionLimit: "Transaction Limit",
  enterAmount: "Enter amount",
  usd: "USD",
  approvalLimit: "Approval Limit",

  accountNumber: "Account Number",
  loanBalance: " Loan Balance",
  actions: "Actions",
  casaAccount: "CASA Account",
  lastActive: "Last Active",
  loanAccount: "Loan Account",
  viewClosedLoans: " View closed loans",
  cardInfo: " Card Info",
  walletInfo: " Wallet Info",
  investmentInfo: " Investment Info",

  addAddress: " Add Address",
  info: "INFO",
  disabled: "Disabled",
  addressID: "Address ID",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  addressLine3: "Address Line 3",
  city: "City",
  stateOrProvince: "State / Province",
  isActive: "is Active ?",
  longitude: "Longitude",
  latitude: "Latitude",
  country: "Country",
  createdDate: "Created Date",
  updatedDate: "Updated Date",
  postalCode: "Postal Code",

  search: "Search",
  detailsForm: "Details form",
  termsForm: "Terms form",
  settingsForm: "Settings form",
  interestRateChartForm: "InterestRateChart form",
  chargesForm: "Charges form",
  review: "Review",
  addLoanChargeMsg: "Loan Charge was successfully added",
  loanTermFrequency: "Loan Term Frequency",
  paymentInformation: "Payment Information",
  interestInformation: "Interest Information",
  depositInformation: "Deposit Information",
  createStandingInstruction: "Create Standing Instruction",
  onArrearsAging: "On Arrears Aging",
  postInterestAasOn: "Post Interest As on",
  deposit: "Deposit",
  withdraw: "Withdraw",
  calculateinterest: "Calculate Interest",
  hold: "Hold",
  assignStaff: "Assign Staff",
  postInterest: "Post Interest",
  addCharge: "Add Charge",
  manageAccount: "Manage Account",
  passfort: "Passfort",
  transferFunds: "Transfer Funds",
  depositMoney: "Deposit Money to Saving Account",
  bank: "Bank",
  interestInformation: "Interest Information",
  selectedCharge: "Selected Charge",
  selectedCharges: "Selected Charges",
  selectedCollateral: "Selected Collateral",
  selectedCollaterals: "Selected Collaterals",
  disburseAmount: "Disburse Amount",
  approvedAmount: "Approved Amount",
  proposedAmount: "Proposed Amount",
  disbursementDate: "Disbursement Date",
  accountInformation: "Account Information",
  transactionId: "Transaction ID",
  transactionType: "Transaction Type",
  paymentDetail: "Payment Detail",
  bankNumber: "Bank Number",
  undoTransactionMsg: "Transaction successfully reversed",
  editTransactionMsg: "Transaction is successfully updated",
  withdrawMoney: "Withdraw Money From Saving Account",
  assignSavingsOfficer: "Assign Savings Officer",
  toSavingsOfficer: "To Savings Officer",
  accountInfo: "Account Information",
  financialInfo: "Financial Information",
  interestRate: "Interest Rate",
  selectedInterestRate: "Selected Interest Rate",
  selectedInterestRates: "Selected Interest Rates",
  closeSavings: "Close Savings Account",
  closedOn: "Closed On",
  withdrawBalance: "Withdraw Balance",
  isInterestPostingRequiredOnClosureDate: "Is Interest Posting required on closure date?",
  viewJournalEntries: "View Journal Entries",
  searchJournalEntries: "Search Journal Entries",
  journalEntries: "Journal Entries",
  account: "Account",
  filter: "Filter",
  dateRange: "Date Range",
  parameters: "Parameters",
  detailJournalEntry: "Journal Entry Detail",
  createdBy: "Created By",
  createdOn: "Created On",
  entryId: "Entry ID",
  office: "Office",
  debit: "Debit",
  paymentTypeId: "Payment Type ID",
  chequeNo: "Cheque No",
  receiptNo: "Receipt No",
  bankNo: "Bank No",
  isInterestPostingRequiredOnClosureDate: "Is Interest Posting required on closure date?",
  isInterestPostingRequiredOnClosureDate: "Is Interest Posting required on closure date?",
  lienTransaction: "Lien Transaction",
  closedDate: "Closed Date",
  transactionId: "Transaction ID",
  lienTransaction: "Lien Transaction",
  search: "Search",
  viewJournalEntries: "View Journal Entries",
  detailJournalEntry: "Journal Entry Detail",
  journalEntries: "Journal Entries",
  searchJournalEntries: "Search Journal Entries",
  searchParams: "Search Parameter",
  filter: "Filter",
  dateRange: "Date Range",
  account: "Account",
  entryId: "Entry ID",
  debit: "Debit",
  credit: "Credit",
  createdBy: "Created By",
  createdOn: "Created On",
  viewJournalEntries: "View journal entries",
  manageJournalEntries: "Manage journal entries",
  filter: "Filter",
  paymentDueAt: "Payment Due at",
  paymentDueAsOf: "Payment Due as of",
  calculationType: "CalculationType",
  paymentDate: "Payment Date",
  chargeInfo: "Charge Information",
  interestRateInfo: "Interest Rate Information",
  collateralInfo: "Collateral Information",
  repaymentInformation: "Repayment Information",
  totalWithdrawalFees: "Total Withdrawal Fees",
  expectedDisbursementDate: "Expected Disbursement Date",
  approvedOn: "Approved On",
  approveLoanAcc: "Approve Loan Account",
  rejectedOn: "Rejected On",
  rejectLoanAcc: "Reject Loan Account",
  rejectLoanAccMsg: "Loan Account Successfully Rejected",
  approveLoanAccMsg: "Loan Account Successfully Approved",
  assignLoanOfficerMsg: "Loan Offcier Successfully Assigned",
  LoanPrepaymentMsg: "Loan Prepayment Successful",
  undoDisbursalMsg: "Loan Disbursal Successfully Reversed",
  undoApprovalMsg: "Loan Approval Successfully Reversed",
  loanDisbursal: "Disburse Loan Account",
  disbursedOnDate: "Disbursed On Date",
  loanDisbursementMsg: "Loan Disbursement Successful",
  loanRepaymentMsg: "Loan Repayment Successful",
  loanRepayment: "Loan Repayment",
  waiveInterestMsg: "Waive Interest Successful",
  writeOffMsg: "Write Off Successful",
  closeAsRescheduledMsg: "Loan Account Successfully Closed",
  collateralType: "Collateral Type",
  addLoanCollateral: "Add Loan Collateral",
  addCollateralMsg: "Loan Collateral Successfully Added",
  foreClosureMsg: "Foreclosure Successful",
  totalWithdrawalFees: "Total Withdrawal Fees",
  modifyApplicationMsg: "Loan Application Successfully Modified",
  modifyApplication: "Edit Loan Application",
  withdrawnOn: "Withdrawn On",
  withdrawLoanAccount: "Withdraw Loan Account",
  withdrawLoanAccountMsg: "Loan Account Successfully Withdrawn",
  chargeInfo: "Charge Information",
  interestRecalculation: "Interest Recalculation",
  frequencyForCompounding: "Frequency For Compounding",
  repaymentInfo: "Repayment Info",
  dueOn: "Due On",

  //LOAN ACCOUNT
  fees: "Fees",
  rescheduleFromInstallment: "Reschedule From Installment On",
  reasonForRescheduling: "Reason For Rescheduling",
  submittedDate: "Submitted Date",
  changeRepaymentDate: "Change Repayment Date",
  installmentRescheduledTo: "Installment Rescheduled To",
  introduceGracePeriod: " Introduce Mid-term grace periods ",
  extendRepaymentPeriod: " Extend Repayment Period",
  adjustInterestRates: "Adjust interest rates for remainder of loan",
  changeEMI: " Change EMI",
  changeFixedPrincipal: "Change Fixed Principal % per installment",
  principalGracePeriods: " Principal Grace Periods",
  interestGracePeriods: " Interest Grace Periods",
  noOfNewRepayments: "Number of New Repayments",
  newInterestRates: "New Interest Rates",
  EMIChange: "EMI Change End Date",
  newEMI: "New EMI",
  newFixedPrincipal: "New Fixed Principal % per instalment ",
  rescheduleMsg: "Loan Reschedule Successful",
  comment: "Comment",
  addLoanTranche: "Add Loan Tranche",
  fixedPrincipal: "Fixed Principal % Per Instalment",
  totalOutstanding: "Total Outstanding",
  totalLate: "Total Late",
  totalInAdvance: "Total In Advance",
  totalInterest: "Total Interest",
  totalFees: "Total Fees",
  totalPenalties: "Total Penalties",
  totalDue: "Total Due",
  totalPaid: "Total Paid",
  totalPricipalDue: "Total Principal Due",
  principalpaymentdetail: "Principal Payment",
  interestspayment: "Interest Payment",
  createChargeLoanTest: "Create Charge Loan Test",
  hideAccruals: "Hide Accruals",
  viewRepaymentSchedule: " View Repayment Schedule",
  hideRepaymentSchedule: " Hide Repayment Schedule",
  rejectRescheduleMsg: "Loan Reschedule Successfully Rejected",
  approveRescheduleMsg: "Loan Reschedule Successfully Approved",
  maximumAllowedOutstandingBalance: "Maximum Allowed Outstanding Balance",
  installmentAmountVariations: "Installation Amount Variations",
  nominalInterestRateFrequency: "Nominal Interest Rate Frequency",

  //END OF LOAN ACCOUNT

  //CURRENT ACCOUNT
  toCurrentOfficer: "To Current Officer",
  currentOfficer: "Current Officer",
  undoApprovalCurrentAcc: "Undo Approval Current Account",
  newCurrentAccount: "New Current Account",
  detailCurrentAccount: "Current Account Detail",
  editCurrentAccount: "Edit Current Account",
  currentAccountsSetup: "Current Account Setup",
  accountInfo: "Account Information",
  newCurrentAccountMsg: "Current Account was successfully created",
  editCurrentAccountMsg: "Current Account was successfully edited",
  deleteCurrentAccountMsg: "Current Account was successfully deleted",
  manageCurrentAccount: "Manage Current Account",
  transactionSuccesfullyProcessed: "Transaction successfully processed",
  AccountSuccefullyApproved: "Account Successfully Approved",
  accountSuccefullyActivated: "Account Successfully Activated",
  transactionDetail: "Transaction detail",
  TransactionSuccessfullyReversed: "Transaction Successfully Reversed",
  assignCurrentOfficer: "Assign Current Officer",
  rejectedOnDate: "Rejected on",
  rejectCurrentAccount: "Reject Current Account",
  withdrawCurrentAccount: "Withdraw Current Account",
  AccountSuccessfullyWithdrawn: "Account Successfully Withdrawn",
  savingsLinkage: "Savings Linkage",
  UnassignCurrentOfficer: "Unassign Current Officer",
  StaffSuccefullyUnassigned: "Staff Successfully Unassigned",
  reasons: "Reasons",
  addChargesCurrentAcc: "Add Current Charges",
  transactionAmount: "Transaction Amount",
  closeCurrentAcc: "Close Current Account",
  updateCurrentAccountMsg: "Current Account Application was successfully modified",
  maxOverdraftLimit: "Max Overdraft Amount should not exceed",
  minOverdraftLimit: "Min Overdraft Amount should not be equal to",
  noOverdraftLimit: "No active overdraft Limit found for this client",
  accountSuccefullyWithdrawn: "Current Account Application was succefully withdrawn",
  currentAccWithdrawnMsg: "Current Account Application was successfully withdrawn",
  currencyCloud: "Currency Cloud",
  fscs: "FSCS",
  clearBank: "ClearBank",
  bicOrRoutingCode: "BIC or Routing Code",
  accountNumberType: "Account Number Type",
  routingCodeType: "Routing Code Type",
  accountNumberAch: "Account Number ACH",
  bicOrRoutingCodeAch: "BIC or Routing Code ACH",
  accountNumberTypeAch: "Account Number Type ACH",
  routingCodeTypeAch: "Routing Code Type ACH",
  multicurrencyAccountPool: "Multicurrency Account Pool",
  fscsEligible: "FSCS Eligible",
  statusCode: "Status Code",
  exclusionIdentifier: "Exclusion Identifier",
  accountId: "Account ID",
  MandateDetails: "Mandate Details",
  assignedDepositorUser: "Assigned Depositor User",
  depositIban: "Deposit IBAN",
  sortCode: "Sort Code",
  editFscsData: "Edit FSCS Data",
  fscsEligible: "FSCS Eligible",
  successfullCalcInterestCurrentAcc: "Current Account Interest was succesfully calculated",
  successfullPostInterestCurrentAcc: "Current Account Interest was succesfully posted",
  viewManagedAccountDetails: "View Managed Account Details",
  editManageCurrentAcc: "Edit Manage Current Account",

  // END OF CURRENT ACCOUNT

  //CASA PRODUCT
  CASAProducts: "CASA Products",
  AddCASAProducts: "New CASA Product",
  ViewCASAProducts: "View CASA Product",
  CASADetailView: "CASA detail",
  EditCASAProducts: "Edit CASA Product",
  CASAProduct: "CASA Product",
  newCasaCreatedMsg: "CASA Product was created sucessfully.",
  editCasaCreatedMsg: "Casa Product was successfully updated",
  productName: "Product Name",
  shortName: "Short Name",
  decimalPlaces: "Decimal Places",
  multiplesOf: "Multiples Of",
  norminalAnnualInterest: "Nominal Annual Interest(%)",
  interestCompoundingPeriod: "Interest Compounding Period",
  interestPostingPeriod: "Interest Posting Period",
  interestCalculatedUsing: "Interest Calculated Using",
  daysInYear: "Days In Year",
  minimumOpeningBalance: "Minimum Opening Balance",
  lockInPeriod: "Lock-in Period",
  applyWithdrawalFeeForTransfers: "Apply Withdrawal Fee for Transfers",
  applyDepositFeeForTransfers: "Apply Deposit fee for transfers	",
  allowOverdraft: "Allow Overdraft	true",
  maxOverdraftLimit: "Max Overdraft limit",
  nominalAnnualInterestForOverdraft: " Nominal Annual Interest For Overdraft",
  minOverdraftRequired: "Min Overdraft Required",
  forInterestCalculation: "For Interest Calculation",
  balanceRequiredForInterestCalculation: "Balance Required For Interest Calculation",
  enforceMinimumBalance: "Enforce Minimum Balance",
  minimumBalance: "Minimum Balance",
  iswithholdTaxApplicable: "Is Withhold Tax Applicable?",
  isDormancyTrackingActive: "Is Dormancy Tracking Active??",
  numberOfDaysToInactiveSubStatus: "Number of Days to Inactive Sub-status",
  numberOfDaysToDormantSubStatus: "Number of Days to Dormant Sub-status",
  numberOfDaysToEscheat: "Number of Days to Escheat",
  casaReference: "CASA Reference",
  assets: " Assets",
  savingReference: "Savings Reference",
  overdraftPortfolio: "Overdraft Portfolio",
  savingsTransfersInSuspense: "Savings Transfers In Suspense",
  interestOnSavings: "Interest On Savings",
  // casaReference: "CASA Reference (Assets)",
  overdraftPortfolio: "Overdraft Portfolio",
  // overdraftPortfolio: "Overdraft Portfolio (Assets)",
  casaControl: "CASA Control",
  // casaControl: "CASA Control (Liabilities)",
  transfersInSupense: "Transfers In Suspense",
  // transfersInSupense: "Transfers In Suspense (Liabilities)",
  escheatLiability: "Escheat Liability",
  // escheatLiability: "Escheat Liability (Liabilities)",
  interestOnCasa: "Interest on CASA",
  // interestOnCasa: "Interest on CASA (Expenses)",
  writeOff: "Write-off",
  // writeOff: "Write-off (Expenses)",
  comissions: "Commissions",
  // comissions: "Commissions (Expenses)",
  incomeFromFee: "Income From Fees",
  // incomeFromFee: "Income From Fees (Income)",
  incomeFromPenalties: "Income From Penalties",
  // incomeFromPenalties: "Income From Penalties (Income)",
  overderaftInterestIncome: "Overdraft Interest Income",
  // overderaftInterestIncome: "Overdraft Interest Income (Income)",
  charge: "Charge",
  charges: "Charges",
  enableDormancyTracking: "Enable Dormancy Tracking ?",

  // END OF SAVINGS ACCOUNT

  // TERM DEPOSIT ACCOUNT
  newLoanAccount: "New Loan Account",
  newDepositAccount: "New Deposit Account",
  accountSetup: "Account Setup",
  details: "Details",
  assets: "Assets",
  terms: "Terms",
  charges: "Charges",
  interestRateChart: "Interest Rate Chart",
  settings: "Settings",
  preview: "Preview",
  liabilities: "Liabilities",
  savingControl: "Savings Control",

  expenses: "Expenses",
  income: "Income",

  // FIXED DEPOSIT ACCOUNT
  withholdTaxGroup: "Withhold Tax Group",
  interestDetails: "Interest Details",
  fixedDepositChargeMsg: "Fixed Deposit Charge Successfully Added",
  addFixedDepositCharge: "Add Fixed Deposit Charge",
  approveFixedDepositAccMsg: "Fixed Deposit Application Successfully Approved",
  approveFixedDepositAcc: "Approve Fixed Deposit Account",
  daysPastDue: "Days Past Due",
  facilityReference: "Facility Reference",
  lastRateChangeDate: "Last Rate Change Date",
  YTDInterestEarned: "YTD Interest Earned",
  FINInterestEarned: "FIN Interest Earned",
  contractReference: "Contract Reference",
  DSGInsuredAmount: "DSG Insured Amount",
  DSGUninsuredAmount: "DSG Uninsured Amount",
  hedgingPortfolioRef: " Hedging Portfolio Ref",
  repoReferenceCashLeg: "Repo Reference Cash Leg",
  universalSourceSystem: "Universal Source System",
  universalBranchId: "Universal Branch Id",
  accountHolderIndicator: "Account Holder Indicator",
  accountStatusCode: "Account Status Code",
  extensionCode: "Extension Code",
  jurisdiction: "Jurisdiction",
  bankRecovery: "Bank Recovery",
  sortCode: "Sort Code",
  dormantDate: "Dormant Date",
  portfolioType: "Portfolio Type",
  IFRS9PortfolioType: "IFRS9 Portfolio Type",
  rateSpread: "Rate Spread",
  dateofPerformanceStatusChange: " Date of Performance Status Change",
  performingStatus: "Performing Status",
  symmetricalInflowRate: "Symmetrical Inflow Rate",
  lastInterestCapitalisationDate: "Last Interest Capitalisation Date",
  universalHQLAIndicator: " Universal HQLA Indicator",
  clientMoneyPlaced: " Client Money Placed",
  depositIban: "Deposit Iban",
  localCurrencyCode: "Local Currency Code",
  legallyDisputed: "Legally Disputed",
  operationalDeposit: "Operational Deposit",
  structuredDepositAccount: "Structured Deposit Account",
  typeofBusinessActivity: "Type of Business Activity",
  institutionWhere: " Institution where is the client money placed?",
  typeofClientAccount: " Type of Client Account for CASS",
  clientClientAccountAcknowledgement: "ClientClient Account Acknowledgement Letter",
  linkedToPeriodic: "Linked to periodic reference rate",
  universalAccumulatedImpairment: "Universal Accumulated Impairment Amount",
  universalGLMarker: "Universal GL Marker",
  beneficiary: "Beneficiary",
  universalImpairmentStatus: "Universal Impairment Status",
  purposeType: "Purpose Type",
  irregularSchedule: "Irregular schedule",
  LDStartDate: "LD Start Date",
  nextRolloverDate: "Next Rollover Date",
  lastRolloverDate: "Last Rollover date",
  LDMaturityDate: "LD Maturity Date",
  repaymentType: "Repayment Type",
  originalTerm: "Original Term",
  remainingTerm: "Remaining Term",
  loanPurchased: "Loan Purchased",
  rolloverIndicator: "Rollover Indicator",
  interestMargin: "Interest Margin",
  forbearanceStatus: "Forbearance Status",
  assessmentType: "Assessment Type",
  additionalStricterPrudentialRequirements: "Additional Stricter Prudential Requirements Flag",
  encumberedAssetFlag: "Encumbered Asset Flag",
  coveredByDGS: "Covered by DGS",
  accumulatedImpairmentAmount: "Accumulated Impairment Amount",
  encumberedAmount: "Encumbered Amount",
  formalArrangement: "Formal arrangement for shortfall",
  dateOfFormalArrangement: "Date of formal arrangement",
  temporarySwitch: "Temporary switch to interest-only",
  dateOfInterestOnly: "Date of interest-only switch",
  paymentsSuspended: "Payments suspended",
  datePaymentsSuspended: "Date payments suspended",
  reducedPayment: "Reduced payment",
  dateOfReducedPayment: "Date of reduced payment",
  termExtension: "Term extension",
  dateOfTermExtension: "Date of term extension",
  otherForbearance: "Other forbearance",
  transactionalAccount: "Transactional Account",
  dateOfOtherForbearance: "Date of other forbearance",
  dateLitigationAction: "Date litigation action started",
  nonPerformingBeforeForbearance: "Non-performing before Forbearance Measures",
  LTV: "LTV (Loan to Value)",
  universalInterestOnMaturity: "Universal Interest On Maturity",
  coverPoolID: "Cover Pool ID",
  centralBankEligible: "Central Bank Eligible Flag",
  nettingFlag: "Netting Flag",
  impairmentStartDate: "Impairment Start Date",
  interestReversionDate: "Interest Reversion Date",
  loanCollateralPool: "Loan Collateral Pool Reference",
  applicationReference: "Application Reference",
  accountDescription: "Account Description",
  transferableEligibleDeposit: "Transferable Eligible Deposit",
  manageFixedDepositAccountDetails: "Manage Fixed Deposit Account Details",
  repoReferenceCashleg: "Repo Reference Cashleg",
  undoApprovalFixedDepositAcc: "Undo Approval of Fixed Deposit Application",
  undoApprovalFixedDepositAccMsg: "Fixed Deposit Application Successfully Unapproved",
  rejectFixedDepositAccount: "Reject Fixed Deposit Account",
  fixedDepositUpdateMsg: "Fixed Deposit Account was Updated",
  rejectFixedDepositMsg: "Fixed Deposit Account was succesfully rejected",
  prematureCloseFixedDeposit: "Premature Closure of Fixed Deposit Account",
  closeFixedDeposit: "Closure of Fixed Deposit Account",
  closeFixedDepositMsg: "Fixed Deposit Account was succesfully closed",
  premClosedDate: "Pre Mature Close Date",
  action: "Action",
  transferDescription: "Transfer Description",
  transferToSavings: "Transfer to Savings",
  depositAmount: "Deposit Amount",
  activationCharge: "Activation Charge",
  fixedDepositAccWithdrawnMsg: "Fixed Deposit Account Application was successfully withdrawn",
  withdrawFixedDepositApp: "Withdraw Fixed Deposit application",
  manageRecurringDepositAccount: "Manage Recurring Deposit Account",
  recurringDepositAccountList: "Recurring Deposit Account List",
  detailRecurringDepositAccount: " Recurring Deposit Account Detail ",
  summary: "Summary",
  previous: "Previous",
  next: "Next",
  moneyMarket: "Money Market",
  manageMoneyMarket: "Manage Money Market",
  newMoneyMarket: "New Money Market",
  productType: "Product Type",
  preferences: "Preferences",
  payments: "Payment Option",
  automaticLiquidation: "Automatic Liquidation",
  trackAccruedInterest: "Track Accrued Interest",
  taxApplicable: "Tax Applicable",
  forwardDatingAllowed: "Forward Dating Allowed",
  allowRollover: "Allow Rollover",
  allowBrokerage: "Allow Brokerage",
  payPastSchedules: "Pay Past Schedules",
  prepaymentPenalty: "Prepayment Penalty",
  intraDayDeal: "Intra Day Deal",
  multiplePenaltyComponents: "Multiple Penalty Components",
  rollover: "Rollover",
  updateUtilization: "Update Utilization",
  deductTaxOnRollover: "Deduct Tax On Rollover",
  applyTax: "Apply Tax",
  rolloverWithInterest: "Rollover With Interest",
  collectedOn: "Collected On",

  certificateTemplate: "Certificate Template",
  certificateTemplatesList: "Certificate Template List",
  templateName: "Template Name",
  templateCode: "Template Code",
  templateType: "Template Type",
  htmlContent: "HTML Content",
  productId: "Product",
  isDefault: "Is Default",
  effectiveFrom: "Effective From",
  effectiveTo: "Effective To",
  newCertificateTemplate: "New Certificate Template",
  editCertificateTemplate: "Edit Certificate Template",
  viewCertificateTemplate: "View Certificate Template",
  detailCertificateTemplate: "Certificate Template Detail",
};

/*!*******************************************************************************!
    !*** CUSTOMER STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  // CERTIFICATE TEMPLATES
  certificateTemplateItems: [{ title: labelConfig.certificateTemplate }],
  certificateTemplateList: "Certificate Template List",
  newCertificateTemplateItems: [
    { title: <Link to="/certificate-template">{labelConfig.certificateTemplate}</Link> },
    { title: labelConfig.newCertificateTemplate },
  ],
  editCertificateTemplateItems: [
    { title: <Link to="/certificate-template">{labelConfig.certificateTemplate}</Link> },
    { title: labelConfig.editCertificateTemplate },
  ],
  viewCertificateTemplateItems: [
    { title: <Link to="/certificate-template">{labelConfig.certificateTemplate}</Link> },
    { title: labelConfig.viewCertificateTemplate },
  ],
  detailCertificateTemplateItems: [
    { title: <Link to="/certificate-template">{labelConfig.certificateTemplate}</Link> },
    { title: labelConfig.detailCertificateTemplate },
  ],
  // CASA Product
  casaProductItems: [{ title: labelConfig.CASAProducts }],
  viewCasaProductItems: [
    { title: <Link to="/prd0100">{labelConfig.CASAProducts}</Link> },
    { title: labelConfig.CASADetailView },
  ],
  newCasaProductItems: [
    { title: <Link to="/prd0100">{labelConfig.CASAProducts}</Link> },
    { title: labelConfig.AddCASAProducts },
  ],
  editCasaProductItems: [
    { title: <Link to="/prd0100">{labelConfig.CASAProducts}</Link> },
    { title: labelConfig.EditCASAProducts },
  ],
  manageBreadcrumbItems: [{ title: labelConfig.manageCustomer }],
  detailBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.manageCustomer}</Link> },
    { title: labelConfig.detailCustomer },
  ],
  newBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.manageCustomer}</Link> },
    { title: labelConfig.newCustomer },
  ],
  editBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.manageCustomer}</Link> },
    { title: labelConfig.editCustomer },
  ],
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  titleData: [
    { value: "mr", label: "Mr." },
    { value: "ms", label: "Ms." },
    { value: "mrs", label: "Mrs." },
  ],
  documentTypeData: [
    { value: "Proof of Identity", label: "Proof of Identity" },
    { value: "Proof of Address", label: "Proof of Address" },
    { value: "Utility Bills", label: "Utility Bills" },
    { value: "clientSignature", label: "Client Signature" },
    { value: "Other", label: "Other" },
  ],
  casaDetailBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.manageCustomer}</Link> },
    { title: labelConfig.casaAccountDetail },
  ],
  recoverFromGuarantorloanDetailBreadcrumbItems: [
    { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanAccountDetail },
  ],
  newAddressBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailCustomer}</Link> },
    { title: labelConfig.newAddress },
  ],

  editAddressBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailCustomer}</Link> },
    { title: labelConfig.editAddress },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],

  productTypeData: [
    { label: "Placement", value: "placement" },
    { label: "Borrowing", value: "borrowing" },
  ],

  paymentsData: [
    { label: "Bearing", value: "bearing" },
    { label: "Discounted", value: "discounted" },
  ],

  rolloverData: [
    { label: "Auto", value: "auto" },
    { label: "Manual", value: "manual" },
  ],

  pepStatusData: [
    { label: "TRUE", value: "true" },
    { label: "FALSE", value: "false" },
  ],
  templateStatusData: [
    { label: "True", value: true },
    { label: "False", value: false },
  ],
  riskRatingData: [
    { label: "HIGH", value: "high" },
    { label: "MEDIUM", value: "medium" },
    { label: "LOW", value: "low" },
  ],
  manageLoanBreadcrumbItems: [{ title: labelConfig.manageLoanAccount }],
  newLoanAccountsBreadcrumbs: [
    { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.newLoanAccount },
  ],
  newRelationshipBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.manageCustomer}</Link> },
    { title: labelConfig.newRelationship },
  ],
  editRelationshipBreadcrumbItems: [
    { title: <Link to="/cst0100">{labelConfig.manageCustomer}</Link> },
    { title: labelConfig.editRelationship },
  ],
  manageSavingsAccountBreadcrumbItems: [{ title: labelConfig.manageSavingsAccount }],

  newSavingsAccountBreadcrumbItems: [
    { title: <Link to="/acc0102">{labelConfig.manageSavingsAccount}</Link> },
    { title: labelConfig.newSavingsAccount },
  ],

  detailSavingsAccountBreadcrumbItems: [
    { title: <Link to="/acc0102">{labelConfig.manageSavingsAccount}</Link> },
    { title: labelConfig.detailSavingsAccount },
  ],
  editSavingsAccountBreadcrumbItems: [
    { title: <Link to="/acc0102">{labelConfig.manageSavingsAccount}</Link> },
    { title: labelConfig.editSavingsAccount },
  ],
  destinationData: [
    { label: "own account", value: 1 },
    { label: "within bank", value: 2 },
  ],
  detailStandingInstructionBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailCustomer}</Link> },
    { title: labelConfig.detailStandingInstruction },
  ],

  editStandingInstructionBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailCustomer}</Link> },
    { title: labelConfig.editStandingInstruction },
  ],
  detailChargeBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailCustomer}</Link> },
    { title: labelConfig.detailCharge },
  ],
  payChargeBreadcrumbItems: [
    // { title: <Link to="/detail-customer">{labelConfig.detailCustomer}</Link> },
    { title: labelConfig.payCharge },
  ],
  loanDetailBreadcrumbItems: [
    { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanAccountDetail },
  ],
  recoverFromGuarantorBreadcrumbItems: [
    // { title: <Link to="/detail-loan-account">{labelConfig.loanAccountDetail}</Link> },
    { title: labelConfig.recoverFromGuarantor },
  ],
  createGuarantorBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.createGuarantor },
  ],
  viewGuarantorsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.viewGuarantors },
  ],
  loanScreenReportsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanScreenReports },
  ],
  addLoanCollateralBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addLoanCollateral },
  ],
  closeAsRescheduledBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeAsRescheduled },
  ],
  loanPrepaymentBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanPrepayment },
  ],
  loanRepaymentBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanRepayment },
  ],
  loanDisbursalBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.loanDisbursal },
  ],
  addLoanChargeBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addLoanCharge },
  ],
  modifyApplicationBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.modifyApplication },
  ],
  approveLoanAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.approveLoanAcc },
  ],
  rejectLoanAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectLoanAcc },
  ],
  assignLoanOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.assignLoanOfficer },
  ],
  foreClosureBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.foreClosure },
  ],
  makeRepaymentBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.makeRepayment },
  ],
  withdrawLoanAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawLoanAccount },
  ],
  journalEntriesBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.journalEntries },
  ],
  undoDisbursalBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.undoDisbursal },
  ],
  undoApprovalBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.undoApproval },
  ],
  waiveInterestBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.waiveInterest },
  ],
  rescheduleBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.reschedule },
  ],
  rescheduleRequestBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rescheduleRequest },
  ],
  writeOffBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.writeOff },
  ],
  closeBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeLoanAccount },
  ],
  viewJournalEntriesBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.journalEntries },
  ],

  manageFixedDepositAccountBreadcrumbItems: [{ title: labelConfig.manageFixedDepositAccount }],
  newFixedDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0106">{labelConfig.manageFixedDepositAccount}</Link>,
    },
    { title: labelConfig.newFixedDepositAccount },
  ],
  detailFixedDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0106">{labelConfig.manageFixedDepositAccount}</Link>,
    },
    { title: labelConfig.detailFixedDepositAccount },
  ],
  editFixedDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0106">{labelConfig.manageFixedDepositAccount}</Link>,
    },
    { title: labelConfig.editFixedDepositAccount },
  ],
  universalSourceSysData: [
    { value: "selectOption", label: "Select Option" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ],
  performingStatusData: [{ value: "selectOption", label: "Select Option" }],
  universalHqlaData: [
    { value: "selectOption", label: "Select Option" },
    { value: "highQuality", label: "High Quality" },
    { value: "extremelyHighQuality", label: "Extremely High Quality" },
  ],
  typeOfClientAccForCassData: [
    { value: "selectOption", label: "Select Option" },
    { value: "clientBankAccount", label: "Client Bank Account" },
    { value: "clientTransactionAccount", label: "Client Transaction Account" },
  ],
  repaymentTypeData: [
    { value: "selectOption", label: "Select Option" },
    { value: "interestOnly", label: "Interest Only" },
    { value: "capitalOnly", label: "Capital Only" },
    { value: "capitalAndInterest", label: "Capital And Interest" },
  ],
  dayWeekMonthYearData: [
    { value: "days", label: "Days" },
    { value: "weeks", label: "Weeks" },
    { value: "months", label: "Months" },
    { value: "years", label: "Years" },
  ],
  maturityInstructionData: [
    { value: 100, label: "Withdraw Deposit" },
    { value: 200, label: "Transfer to Savings" },
    { value: 300, label: "Re-Invest Maturity Amount" },
    { value: 400, label: "Re-Invest Principal Only" },
  ],
  linkSavingsData: [{ value: "gbp", label: "GBP CURRENT ACCOUNT" }],

  //CASA FSCS ELIGIBLE
  fscsEligible: [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ],
  //CASA STATUS CODE
  statusCode: [
    { value: "blank", label: "Blank" },
    { value: "de", label: "DE" },
    { value: "lau", label: "LAU" },
    { value: "sf", label: "SF" },
    { value: "bra", label: "BRA" },
    { value: "dor", label: "DOR" },
    { value: "ga", label: "GA" },
  ],

  //CASA EXCLUSION IDENTIFIER
  exclusionIdentifier: [
    { value: "n/a", label: "N/A" },
    { value: "hmds", label: "HMDS" },
    { value: "legdis", label: "LEGDIS" },
    { value: "legdor", label: "LEGDOR" },
    { value: "ben", label: "BEN" },
  ],

  withdrawBalanceCloseAcc: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],
  isInterestPostingRequiredOnClosureDate: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],
  yesOrNo: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],

  postInterestAasOnBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.postInterestAasOn },
  ],
  depositBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.deposit },
  ],
  withdrawBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdraw },
  ],
  holdBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.hold },
  ],
  assignSavingsOfficerBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.assignSavingsOfficer },
  ],
  addChargeBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addCharge },
  ],
  viewJ: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.searchJournalEntries },
  ],
  detailJournalEntryBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.detailJournalEntry },
  ],

  //SAVINGS ACCOUNT
  withdrawSavingsAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawSavingsAccount },
  ],

  // CURRENT ACCOUNT
  manageCurrentAccountBreadcrumbItems: [{ title: labelConfig.manageCurrentAccount }],
  newCurrentAccountBreadcrumbItems: [
    { title: <Link to="/acc0101">{labelConfig.manageCurrentAccount}</Link> },
    { title: labelConfig.newCurrentAccount },
  ],
  detailCurrentAccountBreadcrumbItems: [
    { title: <Link to="/acc0101">{labelConfig.manageCurrentAccount}</Link> },
    { title: labelConfig.detailCurrentAccount },
  ],
  editCurrentAccountBreadcrumbItems: [
    { title: <Link to="/acc0101">{labelConfig.manageCurrentAccount}</Link> },
    { title: labelConfig.editCurrentAccount },
  ],
  CurrentAccountJournalEntriesBreadcrumbItems: [
    {
      title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link>,
    },
    { title: labelConfig.manageJournalEntries },
  ],
  CurrentAccountUndoApprovalBreadcrumbItems: [
    // { title: <Link to="/detail-current-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalCurrentAcc },
  ],
  rejectCurrentAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectCurrentAccount },
  ],
  withdrawByApplicantCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawCurrentAccount },
  ],
  unassignStaffCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.UnassignCurrentOfficer },
  ],
  addChargesCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.addChargesCurrentAcc },
  ],
  editKycCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.editFscsData },
  ],
  viewManagedAccountDetailsCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.viewManagedAccountDetails },
  ],
  editManageCurrentAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.editManageCurrentAcc },
  ],
  // END OF CURRENT ACCOUNT

  // TERM DEPOSIT ACCOUNT
  manageDepositBreadcrumbItems: [{ title: labelConfig.manageDepositAccount }],
  newDepositAccountsBreadcrumbs: [
    { title: <Link to="/acc0105">{labelConfig.manageDepositAccount}</Link> },
    { title: labelConfig.newDepositAccount },
  ],

  filterOptions: [
    {
      value: " ",
      label: "All",
    },
    {
      value: true,
      label: "Manual Entries",
    },
    {
      value: false,
      label: "System Entries",
    },
  ],
  rejectSavingsAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectSavingsAccount },
  ],
  savingsAccountUndoApprovalBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalSavingsAcc },
  ],
  addSavingsAccountChargeBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addCharge },
  ],

  // FIXED DEPOSIT ACCOUNT
  addFixedDepositChargeBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addFixedDepositCharge },
  ],
  approveFixedDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.approveFixedDepositAcc },
  ],
  manageAccountDetailsBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.manageAccountDetails },
  ],

  undoApprovalFixedDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.undoApprovalFixedDepositAcc },
  ],

  // FIXED DEPOSIT ACCOUNT
  addFixedDepositChargeBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.addFixedDepositCharge },
  ],
  approveFixedDepositAccBreadcrumbItems: [
    // { title: <Link to="/detail-savings-account">{labelConfig.detailCurrentAccount}</Link> },
    { title: labelConfig.approveFixedDepositAcc },
  ],
  rejectFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.rejectFixedDepositAccount },
  ],

  closeSavingsBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeSavingsAcc },
  ],
  prematureCloseFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.prematureCloseFixedDeposit },
  ],
  closeFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.closeFixedDeposit },
  ],
  withdrawFixedDepositAccountBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdrawFixedDepositApp },
  ],

  // RECURRING DEPOSIT
  manageRecurringDepositAccountBreadcrumbItems: [
    { title: labelConfig.manageRecurringDepositAccount },
  ],
  detailRecurringDepositAccountBreadcrumbItems: [
    {
      title: <Link to="/acc0107">{labelConfig.manageRecurringDepositAccount}</Link>,
    },
    { title: labelConfig.detailRecurringDepositAccount },
  ],

  manageMoneyMarketItems: [{ title: labelConfig.manageMoneyMarket }],

  newMoneyMarketItems: [
    { title: <Link to="/prd0607">{labelConfig.manageMoneyMarket}</Link> },
    { title: labelConfig.newMoneyMarket },
  ],
};
